<template>
    <div>
        <p>Visita Tecnica</p>
    </div>
</template>
<script>
export default {
    name:'VisitaTecnica'
    
}
</script>
<style scoped>

</style>